export enum AdminMultimediaListCollectionAction {
  Export,
}
